import { IBaseModel, BaseModel } from "../base.model";

export interface IBMListingViewModel extends IBaseModel {
  apartment?: { apartment_number: number; id: number },
  //name?: string
  block?: {
    id: number,
    address: {
      city: string,
      country: string,
      line1: string,
      line2: string,
      zip_code: string
    },
    name: string,
    block_ref: string
  },
  date_start_building: string,
  date_end_building: string,
  meetings: any[],
  is_archived: boolean,
  creator: {
    firstname: string,
    lastname: string
  }
  /*nb_ko_item?: string
  createdBy?: {
    firstname: string;
    lastname: string;
    id: number
  }*/
  //name?: () => string
}
export class BMListingViewModel extends BaseModel implements IBMListingViewModel {
  apartment?: { apartment_number: number; id: number }
  //name?: string
  block?: {
    id: number
    address: {
      city: string
      country: string
      line1: string
      line2: string
      zip_code: string
    }
    name: string
    block_ref: string
  }
  date_start_building: string
  date_end_building: string
  meetings: any[]
  is_archived: boolean
  creator: {
    firstname: string
    lastname: string
  }
  /*nb_ko_item?: string
  createdBy?: {
    firstname: string;
    lastname: string;
    id: number
  }*/
}



// WEBPACK FOOTER //
// ./src/models/bm/bm-listing.viewmodel.ts